! function() {
    "use strict";
    var t = {
            1287: function(t, e, i) {
                i.d(e, {
                    p: function() {
                        return r
                    }
                });
                var n = i(4662),
                    a = i(4739);
                const r = () => {
                    const t = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
                        e = document.getElementById("main-cart"),
                        i = document.getElementById("mini-cart"),
                        r = document.querySelector("body");
                    t.length && t.forEach(t => t.addEventListener("submit", o => {

  o.preventDefault();
  o.stopPropagation();
  o.stopImmediatePropagation();

  o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') &&
  (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`);

  
                        const s = o.target.querySelector('button[type="submit"]'),
                            c = s.querySelector("span.cart-icon"),
                            l = s.querySelector("svg.loading-icon");
                        r.classList.remove("added-to-cart"), s.classList.add("added"), c.style.display = "none", l.style.display = "block";
                        const d = (0, n.Dz)("javascript");
                        d.headers["X-Requested-With"] = "XMLHttpRequest", delete d.headers["Content-Type"];
                        const u = new FormData(t);
                        u.append("sections", "main-cart"), d.body = u, fetch(`${routes.cartAdd}`, d).then(t => t.json()).then(async t => {
                            o.target.classList.remove("cart-processing");
                            if (t.status) {
                                if (a.A.updateMiniCart(!0), c.style.display = "inline-flex", l.style.display = "none", o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof t.description) return Object.entries(t.description).forEach(([t, e]) => {
                                    const i = `${e.join(", ")}`;
                                    o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + i + "</p>"
                                });
                                o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + t.description + "</p>"
                            } else {
                                if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
                                if (o.target.querySelector(".main-product__error").innerHTML = "", e && e.classList.add("added"), t.sections && null !== t.sections["main-cart"]) a.A.renderItems((new DOMParser).parseFromString(t.sections["main-cart"], "text/html"));
                                else {
                                    const t = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(t).then(t => t.text()).then(t => {
                                        a.A.renderItems((new DOMParser).parseFromString(t, "text/html"))
                                    })
                                }
                                "mini-cart" === cartStrings.uxCart && i && i.open(), o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), s.classList.remove("added"), s.classList.add("successful"), c.style.display = "flex", l.style.display = "none", r.classList.add("added-to-cart")
                            }
                        }).catch(t => {
                            console.error("Error:", t)
                        })
                    }))
                }
            },
            4662: function(t, e, i) {
                i.d(e, {
                    Dz: function() {
                        return n
                    },
                    jW: function() {
                        return a
                    },
                    qF: function() {
                        return s
                    },
                    sg: function() {
                        return r
                    }
                });
                const n = (t = "json") => ({
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/${t}`
                        }
                    }),
                    a = (t = !1) => {
                        const e = window.innerWidth - document.body.offsetWidth,
                            i = document.getElementById("nav-wrapper");
                        t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", i.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", i.style.paddingRight = "0px")
                    };

                function r(t, e) {
                    const i = this;
                    let n;
                    return function() {
                        for (var a = arguments.length, r = new Array(a), o = 0; o < a; o++) r[o] = arguments[o];
                        clearTimeout(n), n = setTimeout(function() {
                            return t.apply(i, r)
                        }, e)
                    }
                }
                document.querySelectorAll(".local-scroll").forEach(t => {
                    t.addEventListener("click", t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        ! function(t, e = 0) {
                            const i = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                a = t.getBoundingClientRect().top;
                            window.scrollTo({
                                top: "off" !== n ? a + window.scrollY - e + parseFloat(i.style.marginTop) : a + window.scrollY - e,
                                behavior: "smooth"
                            })
                        }(document.querySelector(e))
                    })
                });
                const o = {};

                function s(t) {
                    document.removeEventListener("focusin", o.focusin), document.removeEventListener("focusout", o.focusout), document.removeEventListener("keydown", o.keydown), t && t.focus()
                }
            },
            4739: function(t, e, i) {
                var n = i(4662);
                const a = new class {
                    constructor() {
                        this.items = Array.from(document.querySelectorAll(".cart-item")), this.items.forEach(t => this.manageState(t)), this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"], this.mainCartSelector = ".shopify-section.cart", this.miniCart = document.getElementById("mini-cart"), this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty", this.parser = new DOMParser
                    }
                    // manageState(t) {
                    //     const e = t.getAttribute("data-variant-id");
                    //     t.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () => {
                    //         await this.changeCartItem({
                    //             id: e,
                    //             quantity: 0
                    //         }), t.remove()
                    //     });
                    //     const i = t.querySelector('input[name="quantity"]');
                    //     if (!i) return;
                    //     const n = t.querySelector('button[name="plus"]'),
                    //         a = t.querySelector('button[name="minus"]'),
                    //         r = t.querySelector('input[name="quantity"]');
                    //     let o = parseInt(i.value);
                    //     n.addEventListener("click", () => {
                    //         o += 1, i.value = o, this.changeCartItem({
                    //             id: e,
                    //             quantity: o
                    //         })
                    //     }), a.addEventListener("click", () => {
                    //         o -= 1, i.value = o, this.changeCartItem({
                    //             id: e,
                    //             quantity: o
                    //         })
                    //     }), r.addEventListener("change", t => {
                    //         parseInt(t.target.value) > 0 ? (o = parseInt(t.target.value), this.changeCartItem({
                    //             id: e,
                    //             quantity: o
                    //         })) : r.value = o
                    //     }), r.addEventListener("keypress", t => {
                    //         (8 !== t.which && 0 !== t.which && t.which < 48 || t.which > 57) && t.preventDefault()
                    //     })
                    // }

fadeCartItems(start = true) {
  const container = document.querySelector(
    ".cart-items-container, .cart__empty"
  );
  if (!container) return;

  if (start) {
    container.classList.add("is-updating");
  } else {
    container.classList.remove("is-updating");
  }
}


manageState(t) {
  const e = t.getAttribute("data-variant-id");

    const startItemLoading = () => {
    const line = t.getAttribute("data-variant-id");

    const liveItem = document.querySelector(
        `.cart-item[data-variant-id="${line}"]`
    );

    if (liveItem) {
        liveItem.classList.add("is-loading");
    }
    };


  /* ================= REMOVE ================= */
  const removeBtn = t.querySelector(".cart-item-delete, .cart-item__remove");
  if (removeBtn) {
    removeBtn.addEventListener("click", () => {
      startItemLoading();
      this.changeCartItem({ id: e, quantity: 0 });
    });
  }

  const qtyInput = t.querySelector('input[name="quantity"]');
  if (!qtyInput) return;

  const plusBtn = t.querySelector('button[name="plus"]');
  const minusBtn = t.querySelector('button[name="minus"]');

  /* ================= PLUS ================= */
  plusBtn?.addEventListener("click", () => {
    startItemLoading();
    const currentQty = parseInt(qtyInput.value, 10) || 1;
    const newQty = currentQty + 1;

    qtyInput.value = newQty;
    this.changeCartItem({ id: e, quantity: newQty });
  });

  /* ================= MINUS ================= */
  minusBtn?.addEventListener("click", () => {
    startItemLoading();
    const currentQty = parseInt(qtyInput.value, 10) || 1;

    if (currentQty <= 1) {
      this.changeCartItem({ id: e, quantity: 0 });
      return;
    }

    const newQty = currentQty - 1;
    qtyInput.value = newQty;
    this.changeCartItem({ id: e, quantity: newQty });
  });

  /* ================= INPUT ================= */
  qtyInput.addEventListener("change", (ev) => {
    startItemLoading();
    let value = parseInt(ev.target.value, 10);

    if (!value || value < 1) {
      this.changeCartItem({ id: e, quantity: 0 });
      return;
    }

    qtyInput.value = value;
    this.changeCartItem({ id: e, quantity: value });
  });

  /* ================= NUMBERS ONLY ================= */
  qtyInput.addEventListener("keypress", (ev) => {
    if (
      ev.which !== 8 &&
      ev.which !== 0 &&
      (ev.which < 48 || ev.which > 57)
    ) {
      ev.preventDefault();
    }
  });
}

async changeCartItem(t) {

  if (this.isUpdating) return;
  this.isUpdating = true;

  // Fade OUT safely (after DOM is ready)
  requestAnimationFrame(() => {
    this.fadeCartItems(true);
  });

  const request = {
    ...(0, n.Dz)(),
    body: JSON.stringify({
      line: Number(t.id),
      quantity: t.quantity,
      sections: "main-cart"
    })
  };

  fetch(`${routes.cartChange}`, request)
    .then(res => res.json())
    .then(res => {

      const renderCart = (html) => {
        const doc = this.parser.parseFromString(html, "text/html");

        /* ========== EMPTY CART ========== */
if (res.item_count === 0) {

  /* ---------- Replace containers ---------- */
  const currentContainers =
    document.querySelectorAll(this.itemsContainersSelector);

  const newContainer =
    doc.querySelector(this.itemsContainersSelector);

  currentContainers.forEach(el => {
    if (newContainer) {
      el.replaceWith(newContainer.cloneNode(true));
    }
  });

  /* ---------- Update summary ---------- */
  this.renderElements(doc);

  /* 🔥 FORCE FIX (IMPORTANT) */

  // Total
  document.querySelectorAll("#cart-total-price").forEach(el => {
    el.textContent = "Rs. 0";
  });

  // Count
  document.querySelectorAll(".cart-count").forEach(el => {
    el.textContent = "0";
  });

  // Disable checkout
  const checkoutBtn = document.querySelector("#checkout");
  if (checkoutBtn) checkoutBtn.setAttribute("disabled", "disabled");

  // Hide free shipping (optional)
  document.querySelectorAll(".cart-summary__free-shipping").forEach(el => {
    el.style.display = "none";
  });

  // Fade IN
  requestAnimationFrame(() => {
    this.fadeCartItems(false);
  });

  return;
}

        /* ========== NORMAL CART ========== */
        this.renderItems(doc);

        // Fade IN after items render
        requestAnimationFrame(() => {
          this.fadeCartItems(false);
        });
      };

      if (res.sections && res.sections["main-cart"]) {
        renderCart(res.sections["main-cart"]);
      } else {
        fetch(`${window.location.pathname}?section_id=main-cart`)
          .then(r => r.text())
          .then(renderCart);
      }

      /* ========== MINI CART SYNC ========== */
      fetch(`${window.location.pathname}?section_id=navigation-main`)
        .then(r => r.text())
        .then(html => {
          const doc = this.parser.parseFromString(html, "text/html");
          const miniCart = document.querySelector("#mini-cart");
          const newMiniCart = doc.querySelector("#mini-cart");

          if (miniCart && newMiniCart) {
            miniCart.innerHTML = newMiniCart.innerHTML;
            miniCart.addEventListeners?.();
            miniCart
              .querySelectorAll(".icon")
              .forEach(i => i.classList.add("loaded"));
          }
        });

    })
    .catch(err => {
      console.error("Cart update error:", err);
    })
    .finally(() => {
      this.isUpdating = false;

      // Clean item loaders safely
      requestAnimationFrame(() => {
        document
          .querySelectorAll(".cart-item.is-loading")
          .forEach(el => el.classList.remove("is-loading"));
      });
    });
}




                    renderElements(t) {
                        this.selectorsToUpdate.forEach(e => {
                            try {
                                const i = document.querySelectorAll(e),
                                    n = t.querySelector(e);
                                i.length && n && i.forEach(t => {
                                    n.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), t.replaceWith(n.cloneNode(!0))
                                })
                            } catch (t) {
                                console.error(`Error updating ${e}`, t)
                            }
                        });
                        const e = t.querySelector(".cart-count");
                        document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach(t => {
                            e ? (t.classList.contains("visually-hidden") && t.classList.remove("visually-hidden"), t.textContent = e.textContent) : t.classList.add("visually-hidden")
                        }), document.querySelector("#cart-open-block .icon").classList.add("loaded")
                    }
                    renderItems(t) {
                        this.renderElements(t);
                        const e = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            i = t.querySelector(this.itemsContainersSelector);
                        e.forEach(t => {
                            t && t.replaceWith(i.cloneNode(!0))
                        }), document.querySelectorAll(".cart-item").forEach(t => {
                            t.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), this.manageState(t)
                        })
                    }
                    updateMiniCart(t) {
                        return fetch("/?section_id=main-cart").then(t => t.text()).then(e => {
                            this.renderItems((new DOMParser).parseFromString(e, "text/html")), t && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open()
                        }).catch(t => {
                            console.error("Error updating mini cart:", t)
                        })
                    }
                };
                window.cartService = a, window.updateMiniCart = (...t) => a.updateMiniCart(...t), e.A = a, customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
                    constructor() {
                        this.items = Array.from(document.querySelectorAll(".cart-item"));
                        this.items.forEach(t => this.manageState(t));

                        this.selectorsToUpdate = [
                            ".cart-summary__header",
                            "#cart-total-price",
                            "#checkout",
                            ".cart-summary__free-shipping"
                        ];

                        this.mainCartSelector = ".shopify-section.cart";
                        this.miniCart = document.getElementById("mini-cart");
                        this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty";
                        this.parser = new DOMParser();

                        /* 🔒 API LOCK FLAG */
                        this.isUpdating = false;
                        }

                })
            }
        },
        e = {};

    function i(n) {
        var a = e[n];
        if (void 0 !== a) return a.exports;
        var r = e[n] = {
            exports: {}
        };
        return t[n](r, r.exports, i), r.exports
    }
    i.d = function(t, e) {
            for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            })
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        },
        function() {
            var t = i(4662),
                e = i(1287);
            document.addEventListener("DOMContentLoaded", function() {
                document.querySelectorAll(".icon").forEach(t => {
                    t.classList.add("loaded")
                }), document.querySelectorAll('a[target="_blank"]').forEach(t => {
                    t.innerHTML = t.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>"
                }), (0, e.p)()
            }), void 0 !== window.BOOMR && console.log("Built with " + window.BOOMR.themeName + " (https://themes.shopify.com/themes/align/) version " + window.BOOMR.themeVersion + " by Company XYZ (https://companyxyz.io/)."), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(t, e) {
                return function() {
                    return t.apply(e, arguments)
                }
            }, Shopify.setSelectorByValue = function(t, e) {
                for (var i = 0, n = t.options.length; i < n; i++) {
                    var a = t.options[i];
                    if (e == a.value || e == a.innerHTML) return t.selectedIndex = i, i
                }
            }, Shopify.addListener = function(t, e, i) {
                t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
            }, Shopify.postLink = function(t, e) {
                var i = (e = e || {}).method || "post",
                    n = e.parameters || {},
                    a = document.createElement("form");
                for (var r in a.setAttribute("method", i), a.setAttribute("action", t), n) {
                    var o = document.createElement("input");
                    o.setAttribute("type", "hidden"), o.setAttribute("name", r), o.setAttribute("value", n[r]), a.appendChild(o)
                }
                document.body.appendChild(a), a.submit(), document.body.removeChild(a)
            }, Shopify.CountryProvinceSelector = function(t, e, i) {
                this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
            }, Shopify.CountryProvinceSelector.prototype = {
                initCountry: function() {
                    var t = this.countryEl.getAttribute("data-default");
                    Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
                },
                initProvince: function() {
                    var t = this.provinceEl.getAttribute("data-default");
                    t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
                },
                countryHandler: function(t) {
                    var e = (a = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                        i = JSON.parse(e);
                    if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
                    else {
                        for (var n = 0; n < i.length; n++) {
                            var a;
                            (a = document.createElement("option")).value = i[n][0], a.innerHTML = i[n][1], this.provinceEl.appendChild(a)
                        }
                        this.provinceContainer.style.display = ""
                    }
                },
                clearOptions: function(t) {
                    for (; t.firstChild;) t.removeChild(t.firstChild)
                },
                setOptions: function(t, e) {
                    var i = 0;
                    for (e.length; i < e.length; i++) {
                        var n = document.createElement("option");
                        n.value = e[i], n.innerHTML = e[i], t.appendChild(n)
                    }
                }
            }, document.querySelectorAll("video").forEach(t => {
                t.muted = !0, new IntersectionObserver(e => {
                    e.forEach(e => {
                        e.isIntersecting ? 1 == t.autoplay && t.paused && t.play().catch(t => {
                            "AbortError" !== t.name && console.error("Error playing video:", t)
                        }) : t.pause()
                    })
                }, {
                    threshold: 0
                }).observe(t)
            }), document.querySelectorAll("video.hover-play").forEach(t => {
                const e = t.closest(".card");
                t.pause(), e ? (e.addEventListener("mouseenter", () => {
                    t.play().catch(t => {
                        "AbortError" !== t.name && console.error("Error playing video:", t)
                    })
                }), e.addEventListener("mouseleave", () => {
                    t.pause()
                })) : (t.addEventListener("mouseenter", () => {
                    t.play().catch(t => {
                        "AbortError" !== t.name && console.error("Error playing video:", t)
                    })
                }), t.addEventListener("mouseleave", () => {
                    t.pause()
                }))
            });
            const n = function() {
                [].slice.call(document.querySelectorAll("video")).forEach(t => {
                    const e = t.parentElement.querySelector(".figure--video__poster");
                    e && e.addEventListener("click", () => {
                        e.classList.add("hidden"), t.play()
                    })
                });
                var t = [].slice.call(document.querySelectorAll(".figure--video-external"));
                if ("IntersectionObserver" in window) {
                    var e = new IntersectionObserver(function(t, e) {
                        t.forEach(function(t) {
                            if (t.isIntersecting) "vimeo" == t.target.dataset.type && fetch("http://vimeo.com/api/v2/video/" + t.target.dataset.id + ".json").then(t => {
                                if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                                return t.json()
                            }).then(e => {
                                t.target.querySelector(".figure--video__external-poster-image").src = e[0].thumbnail_large
                            }), t.target.addEventListener("click", function() {
                                if (!t.target.querySelector("iframe")) {
                                    let t = this.dataset.type,
                                        e = document.createElement("iframe");
                                    e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", ""), e.setAttribute("allow", "autoplay"), "youtube" == t ? (e.setAttribute("id", "youtube"), e.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1")) : e.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"), this.appendChild(e), setTimeout(() => {
                                        this.querySelector(".figure--video__poster").classList.add("hidden")
                                    }, 350)
                                }
                            });
                            else if (t.target.querySelector("iframe")) {
                                let i = t.target.dataset.type,
                                    n = t.target.querySelectorAll("iframe");
                                if ("youtube" == i) {
                                    var e = {
                                        event: "command",
                                        func: "pauseVideo"
                                    };
                                    n[0].contentWindow.postMessage(JSON.stringify(e), "*")
                                } else "vimeo" == i && (e = {
                                    method: "pause",
                                    value: "true"
                                }, n[0].contentWindow.postMessage(JSON.stringify(e), "*"))
                            }
                        })
                    });
                    t.forEach(function(t) {
                        e.observe(t)
                    })
                }
            };
            n(), window.addEventListener("beforeprint", () => {
                const t = document.body.querySelectorAll("details"),
                    e = document.body.querySelectorAll("img");
                for (let e = 0; e < t.length; e++) t[e].open ? t[e].dataset.open = "1" : t[e].setAttribute("open", "");
                for (let t = 0; t < e.length; t++) e[t].dataset.open = "1"
            }), window.addEventListener("afterprint", () => {
                const t = document.body.querySelectorAll("details");
                for (let e = 0; e < t.length; e++) t[e].dataset.open ? t[e].dataset.open = "" : t[e].removeAttribute("open")
            }), Shopify.designMode && document.addEventListener("shopify:section:load", () => {
                n(), document.querySelectorAll(".icon").forEach(t => {
                    t.classList.add("loaded")
                })
            });
            class a extends HTMLElement {
                constructor() {
                    super(), this.addEventListener("change", t => {
                        const e = new CustomEvent("variant-update", {
                            detail: {
                                event: t,
                                section: this.dataset.section,
                                product: this.dataset.product,
                                block: this.dataset.block
                            },
                            bubbles: !0
                        });
                        this.dispatchEvent(e)
                    }), document.addEventListener("variant-update", t => {
                        this.dataset.section === t.detail.section && this.dataset.product === t.detail.product && this.dataset.block === t.detail.block && (t.detail.event.target.closest("variant-selects") !== this && this.syncSelection(t.detail.event.target), this.onVariantChange())
                    }), this.isCardBasedProductForm = null !== this.closest(".card__content")
                }
                connectedCallback() {
                    this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product, this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product + (this.dataset.block ? "-" + this.dataset.block : "")
                }
                // onVariantChange() {
                //     this.updateOptions(), this.updateMasterId(), this.currentVariant ? (this.updateVariantStatuses(), this.updateImageSwatches(), this.updateMedia(), this.updateURL(), this.updateLinks(), this.renderProductInfo(), this.updateVariantInput(), this.updateAddToCart()) : void 0 === this.currentVariant && this.setUnavailable()
                // }

                onVariantChange() {

    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {

        this.updateVariantStatuses();
        this.updateImageSwatches();

        // SAFE MEDIA CHECK
        if (
            this.querySelector('[data-media-id]') ||
            document.querySelector(`#Gallery-${this.dataset.section}`) ||
            document.querySelector(`#gallery-${this.dataset.section}`)
        ) {
            this.updateMedia();
        }

        this.updateURL();
        this.updateLinks();
        this.renderProductInfo();
        this.updateVariantInput();
        this.updateAddToCart();

    } else if (this.currentVariant === undefined) {

        this.setUnavailable();

    }
}

                syncSelection(t) {
                    const {
                        name: e,
                        value: i
                    } = t, n = this.querySelector(`[name="${e}"]`), a = n?.tagName;
                    n && ("SELECT" === a ? this.querySelector(`[name="${e}"] [value="${i}"]`).selected = !0 : this.querySelector(`[name="${e}"][value="${i}"]`).checked = !0)
                }
                updateOptions() {
                    this.options = Array.from(this.querySelectorAll("select, fieldset"), t => "SELECT" === t.tagName ? t.value : "FIELDSET" === t.tagName ? Array.from(t.querySelectorAll("input")).find(t => t.checked)?.value : void 0)
                }
                updateMasterId() {
                    this.options.includes(void 0) ? this.currentVariant = null : this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
                }
                updateVariantStatuses() {
                    const t = this.querySelector(":checked").value,
                        e = this.getVariantData().filter(e => e.options[0] === t);
                    this.getProductVariantSelects().forEach(t => {
                        const i = t.querySelectorAll("select, fieldset");
                        i.forEach((t, n) => {
                            if (0 === n) return;
                            const a = t.querySelectorAll('input[type="radio"], option'),
                                r = i[n - 1].querySelector(":checked").value,
                                o = e.filter(t => t.available && t[`option${n}`] === r).map(t => t[`option${n+1}`]);
                            this.setInputAvailability(a, o)
                        })
                    })
                }
                setInputAvailability(t, e) {
                    t.forEach(t => {
                        const i = t.getAttribute("value"),
                            n = e.includes(i);
                        "OPTION" === t.tagName && (t.innerText = n ? i : window.productStrings.unavailable_with_option.replace("[value]", i))
                    })
                }
                updateImageSwatches() {
                    this.querySelectorAll("fieldset:has(.image-swatch)").forEach(t => {
                        const e = t.dataset.optionPosition,
                            i = t.querySelectorAll(".image-swatch");
                        for (const t of i) {
                            const i = [...this.options];
                            i[e - 1] = t.value;
                            const n = this.getVariantData().find(t => t.options[0] == i[0] && t.options[1] == i[1] && t.options[2] == i[2]);
                            if (!n) continue;
                            const a = t.labels[0],
                                r = a.querySelectorAll("img.variant-image"),
                                o = a.querySelector(`img[data-variant-id="${n.id}"]`),
                                s = a.querySelector(".image_swatch--text_value");
                            r.forEach(t => {
                                t.classList.add("hidden")
                            }), s.classList.add("u-hide"), o ? o.classList.remove("hidden") : s.classList.remove("u-hide")
                        }
                    })
                }
                updateMedia() {
                    if (!this.currentVariant) return;
                    if (!this.currentVariant.featured_media) return;
                    const t = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
                        e = t.dataset.variantStyle;
                    if (this.currentVariant.featured_media) {
                        const i = this.currentVariant.featured_media.id;
                        if ("default" == e)
                            if (t.swiper.initialized) {
                                const e = t.swiper.virtual?.slides?.length ? t.swiper.virtual.slides : t.swiper.slides,
                                    n = Array.from(e).findIndex(t => t.dataset.id == i); - 1 !== n && t.swiper.slideToLoop(n)
                            } else {
                                const e = t.querySelector(`[data-id="${i}"]`);
                                e && t.prepend(e)
                            }
                        else if ("variant" == e) {
                            const e = t.querySelector(`[data-id="${i}"]`);
                            e && (t.firstChild.classList.add("u-hide"), e.classList.remove("u-hide"), t.prepend(e))
                        }
                        const n = document.querySelector(`#sticky-gallery-${this.uniqueIdentifier}`);
                        if (n) {
                            const t = n.querySelectorAll(".sticky-add-to-cart__image"),
                                e = this.currentVariant.id;
                            t.forEach(t => {
                                t.dataset.variantId == e ? t.classList.remove("u-hide") : t.classList.add("u-hide")
                            })
                        }
                    }
                }
                updateURL() {
                    if ("false" === this.dataset.updateUrl) return;
                    const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
                    window.history.replaceState({}, "", t)
                }
                updateLinks() {
                    if (!this.isCardBasedProductForm) return;
                    const t = this.closest(".card__content").querySelector(".button--view-product");
                    "A" === t?.tagName && (t.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`)
                }
                updateVariantInput() {
                    document.querySelectorAll(`#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`).forEach(t => {
                        const e = t.querySelector('input[name="id"]');
                        e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    })
                }
                renderProductInfo() {
                    const e = document.getElementById(`price-${this.uniqueIdentifier}`);
                    e && (e.classList.contains("price--on-sale") ? e.querySelectorAll(".price__sale .price-item").forEach(t => t.classList.add("skeleton-loading")) : e.querySelector(".price__regular").classList.add("skeleton-loading"));
                    const i = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                    i && (i.classList.contains("price--on-sale") ? i.querySelectorAll(".price__sale .price-item").forEach(t => t.classList.add("skeleton-loading")) : i.querySelector(".price__regular").classList.add("skeleton-loading"));
                    const n = document.getElementById(`pickup-availability-${this.uniqueIdentifier}`);
                    n?.querySelector(".skeleton-loading-wrapper")?.classList.add("skeleton-loading");
                    const a = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                    a?.classList.add("skeleton-loading");
                    const r = document.getElementById(`pickup-availability-modal-${this.uniqueIdentifier}`);
                    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`).then(t => t.text()).then(o => {
                        const s = (new DOMParser).parseFromString(o, "text/html"),
                            c = s.getElementById(`price-${this.mainProductUniqueIdentifier}`);
                        if (a) {
                            const t = s.getElementById(`stock-status-${this.mainProductUniqueIdentifier}`);
                            t ? (a.classList.remove("u-invisible"), a.innerHTML = t.innerHTML, a.classList = t.classList) : a?.classList.add("u-invisible")
                        }
                        if (c && e ? (e.classList.remove("u-invisible"), e.innerHTML = c.innerHTML, e.classList = c.classList) : e?.classList.add("u-invisible"), i) {
                            const t = s.getElementById(`sticky-price-${this.mainProductUniqueIdentifier}`);
                            t ? (i.classList.remove("u-invisible"), i.innerHTML = t.innerHTML, i.classList = t.classList) : i?.classList.add("u-invisible")
                        }
                        if (n) {
                            const t = s.getElementById(`pickup-availability-${this.mainProductUniqueIdentifier}`);
                            t && (n.innerHTML = t.innerHTML, n.classList = t.classList)
                        }
                        if (r) {
                            const t = s.getElementById(`pickup-availability-modal-${this.mainProductUniqueIdentifier}`);
                            t && (r.innerHTML = t.innerHTML)
                        }
                        const l = document.querySelector(".pickup-availability"),
                            d = document.getElementById("overlay"),
                            u = document.getElementById("pickup-availability-open"),
                            h = document.getElementById("pickup-availability-close");
                        u && document.getElementById("pickup-availability-open").addEventListener("click", function() {
                            l.classList.add("open"), d.classList.add("open"), document.body.classList.add("active", "minicart"), (0, t.jW)(!0)
                        }), h && document.getElementById("pickup-availability-close").addEventListener("click", function() {
                            l.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, t.jW)(!1), overlay.classList.remove("open", "overlay--all"), (0, t.qF)(l)
                        })
                    })
                }
                updateAddToCart() {
                    const t = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
                    t && (this.currentVariant.available ? t.forEach(t => {
                        const e = t.querySelector('[name="add"]'),
                            i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        e && (e.removeAttribute("disabled"), i.textContent = `${cartStrings.addToCart}`)
                    }) : t.forEach(t => {
                        const e = t.querySelector('[name="add"]'),
                            i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        e && (e.setAttribute("disabled", "disabled"), i.textContent = `${cartStrings.soldOut}`)
                    }))
                }
                setUnavailable() {
                    const t = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`),
                        e = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                    t.forEach(t => {
                        const i = t.querySelector('[name="add"]'),
                            n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        i && (n.textContent = `${cartStrings.unavailable}`, i.setAttribute("disabled", "disabled"), e && (e.dataset.state = "unavailable"))
                    });
                    const i = document.getElementById(`price-${this.uniqueIdentifier}`),
                        n = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                    i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n)
                }
                setPriceUnavailable(t) {
                    t.classList.remove("price--on-sale"), t.classList.add("price--sold-out"), t.querySelector(".price__regular .price-item.price-item--regular").textContent = window.productStrings.price_unavailable
                }
                getVariantData() {
                    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
                }
                getProductVariantSelects() {
                    return document.querySelectorAll(`variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`)
                }
            }
            customElements.get("variant-selects") || customElements.define("variant-selects", a);
            class r {
                constructor(t) {
                    this.el = t, this.summary = t.querySelector("summary"), this.content = t.querySelector(".content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", t => this.onClick(t))
                }
                onClick(t) {
                    t.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
                }
                shrink() {
                    this.isClosing = !0;
                    const t = `${this.el.offsetHeight}px`,
                        e = `${this.summary.offsetHeight}px`;
                    this.animation && this.animation.cancel(), this.animation = this.el.animate({
                        height: [t, e]
                    }, {
                        duration: 400,
                        easing: "ease-out"
                    }), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
                }
                open() {
                    this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame(() => this.expand())
                }
                expand() {
                    this.isExpanding = !0;
                    const t = `${this.el.offsetHeight}px`,
                        e = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
                    this.animation && this.animation.cancel(), this.animation = this.el.animate({
                        height: [t, e]
                    }, {
                        duration: 400,
                        easing: "ease-out"
                    }), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
                }
                onAnimationFinish(t) {
                    this.el.open = t, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
                }
            }
            document.querySelectorAll("details.accordion__wrapper").forEach(t => {
                new r(t)
            })
        }()
}();


document.addEventListener('cart:updated', initCartUpsell);

function initCartUpsell() {
  const upsellSlider = document.querySelector('.cart-upsell__slider');
  if (!upsellSlider || upsellSlider.swiper) return;

  new Swiper(upsellSlider, {
    slidesPerView: 2.2,
    spaceBetween: 12,
    observer: true,
    observeParents: true
  });
}

// // FSSAI POPUP SCRIPT:
//   function openFssaiPopup() {
//     document.getElementById("fssaiPopup").style.display = "flex";
//   }

//   function closeFssaiPopup() {
//     document.getElementById("fssaiPopup").style.display = "none";
//   }

//   document.addEventListener("DOMContentLoaded", function () {

//     // 🔍 Auto-search the page for "FSSAI" and convert to clickable link
//     function replaceTextWithPopup(node) {
//       const regex = /\bFSSAI\b/g;

//       if (node.nodeType === 3 && regex.test(node.nodeValue)) {
//         const span = document.createElement("span");
//         span.innerHTML = node.nodeValue.replace(
//           regex,
//           '<a href="#" class="fssai-link" onclick="openFssaiPopup(); return false;">FSSAI</a>'
//         );
//         node.parentNode.replaceChild(span, node);
//       } 
//       else if (
//         node.nodeType === 1 &&
//         node.childNodes &&
//         !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.tagName)
//       ) {
//         node.childNodes.forEach(replaceTextWithPopup);
//       }
//     }

//     replaceTextWithPopup(document.body);
//   });


// FSSAI POPUP SCRIPT:
  function openFssaiPopup() {
    document.getElementById("fssaiPopup").style.display = "flex";
  }

  function closeFssaiPopup() {
    document.getElementById("fssaiPopup").style.display = "none";
  }

  document.addEventListener("DOMContentLoaded", function () {

    function replaceTextWithPopup(node) {
      const regex = /\bFSSAI\b/g;

      // ❌ Skip footer completely
      if (
        node.closest &&
        (node.closest("footer") || node.closest(".footer") || node.closest(".site-footer"))
      ) {
        return;
      }

      if (node.nodeType === 3 && regex.test(node.nodeValue)) {
        const span = document.createElement("span");
        span.innerHTML = node.nodeValue.replace(
          regex,
          '<a href="#" class="fssai-link" onclick="openFssaiPopup(); return false;">FSSAI</a>'
        );
        node.parentNode.replaceChild(span, node);
      } 
      else if (
        node.nodeType === 1 &&
        node.childNodes &&
        !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.tagName)
      ) {
        node.childNodes.forEach(replaceTextWithPopup);
      }
    }

    replaceTextWithPopup(document.body);
  });


//   CUSTOM JS

document.addEventListener("click", function (e) {

  const form = e.target.closest('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const btn = form.querySelector('button[type="submit"]');
  if (!btn || btn.dataset.observerAttached === "true") return;

  btn.dataset.observerAttached = "true";

  const observer = new MutationObserver(() => {

    if (btn.classList.contains("successful")) {

      setTimeout(() => {

        btn.classList.remove("successful");

        const textSpan = btn.querySelector('span:not(.cart-icon):not(:empty)');
        if (textSpan) {
          textSpan.textContent = cartStrings.addToCart;
        }

      }, 3000);

    }

  });

  observer.observe(btn, { attributes: true });

});

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".custom-video-wrapper");
  if (!wrapper) return;

  const btn = wrapper.querySelector(".video-play-btn");
  const video = wrapper.querySelector("video");
  const poster = wrapper.querySelector(".video-poster");

  btn.addEventListener("click", () => {
    video.style.display = "block";
    if (poster) poster.style.display = "none";
    btn.style.display = "none";

    video.play();
  });
});




// CUSTOM JS

document.addEventListener("DOMContentLoaded", function () {

// page redirection
const redirectionMapping = {
    '/products/no-nonsense-plant-protein-5': '/collections/no-nonsense-plant-protein',
    '/products/bundle-500g': '/products/build-your-own-bundle-500gms',
    '/products/sachets-bundle': '/products/build-your-own-bundle-single-serve-sachets',
    '/pages/no-nonsense-protein': '/collections/no-nonsense-plant-protein',
    '/pages/bundle-500g': '/products/build-your-own-bundle-500gms',
    '/pages/bundle-sachets': '/products/build-your-own-bundle-single-serve-sachets',
    '/collections/build-your-own-bundle': '/pages/build-your-own-bundle',
    '/products/no-nonsense-plant-protein-chikmagalur-mocha?variant=42889414672477': '/products/no-nonsense-plant-protein-chikmagalur-mocha?variant=40474785972317',
    '/products/no-nonsense-plant-protein-chikmagalur-mocha?variant=40474786037853': '/products/no-nonsense-plant-protein-chikmagalur-mocha?variant=40474785972317',
    '/products/no-nonsense-plant-protein-ratnagiri-mango?variant=43154777669725': '/products/no-nonsense-plant-protein-ratnagiri-mango?variant=42168546132061',
    '/products/no-nonsense-plant-protein-malnad-arabica-coffee?variant=41300289585245': '/products/no-nonsense-plant-protein-malnad-arabica-coffee?variant=41300289519709',
    '/products/no-nonsense-plant-protein-pina-colada?variant=43154777636957': '/products/no-nonsense-plant-protein-pina-colada?variant=41003302649949',
    '/products/no-nonsense-plant-protein-mahabaleshwar-strawberry?variant=43260964995165': '/products/no-nonsense-plant-protein-mahabaleshwar-strawberry?variant=41300265599069'
};

const currentUrl = window.location.href;

for (const [oldPath, newPath] of Object.entries(redirectionMapping)) {
    if (currentUrl.includes(oldPath)) {
        window.location.href = newPath;
        break;
    }
}
});

// Create a mapping of existing URLs to redirect URLs
const redirects = {
"https://cosmix.in/collections/no-nonsense-plant-protein/matcha": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/all/shop": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/all/indonesian_cacao": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/no-nonsense-plant": "https://cosmix.in/collections/no-nonsense-plant-protein",
// "https://cosmix.in/products/limited-edition-bundle": "https://cosmix.in/collections/bundles",
"https://cosmix.in/collections/no-nonsense-plant-protein/vanilla_bean": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/all/cocoa_beet": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/no-nonsense-plant-protein/indonesian_cacao": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/test-collection-for-coupon": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/all": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/shop/shop": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/best-sellers-1/best-sellers": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/all/immunity": "https://cosmix.in/collections/immunity",
"https://cosmix.in/collections/bundles/hair-health": "https://cosmix.in/collections/bundles",
"https://cosmix.in/collections/shop/holistic-health": "https://cosmix.in/collections/holistic-health-1",
"https://cosmix.in/collections/shop/hormonal-health": "https://cosmix.in/collections/hormonal-health",
"https://cosmix.in/collections/shop/caffeine-alternatives": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/immunity/caffeine-alternatives": "https://cosmix.in/collections/immunity",
"https://cosmix.in/collections/best-sellers-1/stamina-focus": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/all/stamina-focus": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/no-nonsense-plant/vanilla_bean": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/hormonal-health/stamina-focus": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/vendors": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/no-nonsense-plant-protein-flavours/vanilla_bean": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/shop/relax": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/relax/stress-relief": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/all/caffeine-alternatives": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/all-products-except-diwali/shop": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/best-sellers/stress-relief": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/best-sellers/digestion": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/shop/energy": "https://cosmix.in/collections/energy",
"https://cosmix.in/collections/shop/digestion": "https://cosmix.in/collections/digestion",
"https://cosmix.in/collections/shop-our-cosmix": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/bundles/skin-health": "https://cosmix.in/collections/bundles",
"https://cosmix.in/collections/all-products-except-diwali/digestion": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/shop-our-cosmix/skin-health": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/no-nonsense-plant-protein/cocoa_beet": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/all/hormonal-health": "https://cosmix.in/collections/hormonal-health",
"https://cosmix.in/collections/shop/stress-relief": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/all/stress-relief": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/shop/skin-health": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/shop/stamina-focus": "https://cosmix.in/collections/energy",
"https://cosmix.in/collections/shop/best-sellers": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/all-products-except-diwali/stress-relief": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/all/overall-health": "https://cosmix.in/collections/holistic-health-1",
"https://cosmix.in/collections/relax/relax": "https://cosmix.in/collections/relax",
"https://cosmix.in/collections/all/skin-health": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/best-sellers-1/relax": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/shop/overall-health": "https://cosmix.in/collections/holistic-health-1",
"https://cosmix.in/collections/no-nonsense-plant/indonesian_cacao": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/no-nonsense-plant/digestion": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/all/digestion": "https://cosmix.in/collections/digestion",
"https://cosmix.in/collections/best-sellers-1/stress-relief": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/all/vanilla_bean": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/all/hair-health": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/all/classic_unflavoured": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/bundles/digestion": "https://cosmix.in/collections/bundles",
"https://cosmix.in/collections/beauty-inside-out": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/shop/immunity": "https://cosmix.in/collections/immunity",
"https://cosmix.in/collections/relax/best-sellers": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/no-nonsense-plant-protein-flavours/cocoa_beet": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/beauty-inside-out/skin-health": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/beauty-inside-out/hair-health": "https://cosmix.in/collections/skin-and-hair",
"https://cosmix.in/collections/shop-our-cosmix/overall-health": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/best-sellers/caffeine-alternatives": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/best-sellers/skin-health": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/products/no-nonsense-plant-protein-indonesian-cacao-copy": "https://cosmix.in/products/real-indonesian-cacao",
"https://cosmix.in/collections/functional-foods": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/no-nonsense-plant-protein-flavours": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/collections/community-favorites": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/community-favorites-new": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/cosmix-essentials": "https://cosmix.in/collections/shop",
"https://cosmix.in/collections/build-your-own-bundle": "https://cosmix.in/pages/build-your-own-bundle",
"https://cosmix.in/collections/protein-bestsellers": "https://cosmix.in/collections/best-sellers",
"https://cosmix.in/collections/protein-all-flavours-protein-page": "https://cosmix.in/collections/no-nonsense-plant-protein",
"https://cosmix.in/blogs/skin-1": "https://cosmix.in/blogs/beauty",
"https://cosmix.in/blogs/health": "https://cosmix.in/blogs/blog",
"https://cosmix.in/blogs/lifestyle": "https://cosmix.in/blogs/blog",
"https://cosmix.in/blogs/protein": "https://cosmix.in/blogs/nutrition",
"https://cosmix.in/collections/protein": "https://cosmix.in/collections/no-nonsense-plant-protein"
};

// Function to check and perform redirection
function checkRedirects() {
    const currentUrl = window.location.href;

    if (redirects[currentUrl]) {
        window.location.replace(redirects[currentUrl]);
    }
}

// Execute the redirect check
checkRedirects();


// CART UPSELL SWITCH COLLECTIONS
function initCartUpsellToggle() {

  const wrapper = document.querySelector('.mini-cart__upsell');

  if (!wrapper) return;

  const defaultBlock = wrapper.querySelector('.upsell-default');
  const thresholdBlock = wrapper.querySelector('.upsell-threshold');

  if (!defaultBlock || !thresholdBlock) return;

  const threshold = Number(
    wrapper.dataset.threshold || 1500
  );

  const totalEl = document.querySelector('#cart-total-price');

  if (!totalEl) return;

  const total = Number(
    totalEl.textContent.replace(/[^\d]/g, '')
  );

  if (total >= threshold) {
    if (defaultBlock.style.display !== 'none') {
      defaultBlock.style.display = 'none';
      thresholdBlock.style.display = '';
    }
  } else {
    if (thresholdBlock.style.display !== 'none') {
      defaultBlock.style.display = '';
      thresholdBlock.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', initCartUpsellToggle);

/* fallback */
setInterval(initCartUpsellToggle, 500);



// PRODUCT INFO ACCORDION - VARIANT SYNC
function initProductInfoVariantSync() {
  const tableWrappers = document.querySelectorAll('.product-info-table-wrapper');
  if (!tableWrappers.length) return;

  function updateVariantInfo(variantId) {
    if (!variantId) return;

    tableWrappers.forEach((wrapper) => {
      const container = wrapper.closest('.nn-accordion') || wrapper.parentElement;
      const jsonEl = container.querySelector('.product-info-variants-json');
      if (!jsonEl) return;

      try {
        const variantsData = JSON.parse(jsonEl.textContent);
        const variant = variantsData[variantId];
        if (!variant) return;

        function getCleanTitle(str) {
          if (!str || str === 'Default Title') return '';
          return str.replace(/\s*\([^)]*save[^)]*\)/gi, '').replace(/\s*\([^)]*off[^)]*\)/gi, '').trim();
        }

        const netQtyRow = wrapper.querySelector('.product-info-net-quantity-row');
        const netQtyEl = wrapper.querySelector('.product-info-net-quantity');
        if (netQtyRow && netQtyEl) {
          const netQtyVal = (variant.net_quantity !== null && variant.net_quantity !== undefined) ? String(variant.net_quantity).trim() : '';
          if (netQtyVal !== '') {
            netQtyEl.textContent = netQtyVal;
            netQtyRow.style.display = '';
          } else {
            netQtyRow.style.display = 'none';
          }
        }

        const netWeightRow = wrapper.querySelector('.product-info-net-weight-row');
        const netWeightEl = wrapper.querySelector('.product-info-net-weight');
        if (netWeightRow && netWeightEl) {
          const netWeightVal = (variant.net_weight !== null && variant.net_weight !== undefined) ? String(variant.net_weight).trim() : '';
          if (netWeightVal !== '') {
            netWeightEl.textContent = netWeightVal;
            netWeightRow.style.display = '';
          } else {
            netWeightRow.style.display = 'none';
          }
        }
      } catch (err) {
        console.error('Error parsing product info variant data:', err);
      }
    });
  }

  // Variant update event listener
  document.addEventListener('variant-update', function (e) {
    const variantSelects = e.detail?.event?.target?.closest('variant-selects');
    if (variantSelects && variantSelects.currentVariant) {
      updateVariantInfo(variantSelects.currentVariant.id);
    }
  });

  // Change event on input[name="id"] or variant inputs
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'id' || e.target.matches('input[name="id"]'))) {
      if (e.target.value) {
        updateVariantInfo(e.target.value);
      }
    }
    const variantSelects = e.target.closest('variant-selects');
    if (variantSelects && variantSelects.currentVariant) {
      updateVariantInfo(variantSelects.currentVariant.id);
    }
  });

  // Initial check on load
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariantId = urlParams.get('variant') || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"], input[name="id"]')?.value;
  if (currentVariantId) {
    updateVariantInfo(currentVariantId);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductInfoVariantSync);
} else {
  initProductInfoVariantSync();
}



// GLOBAL PRODUCT CARD SINGLE CLICK HANDLER
function initProductCardDirectClick() {
  document.addEventListener('click', function (e) {
    // Only handle primary (left) click without modifier keys
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) {
      return;
    }

    // Ignore interactive controls inside the card
    if (e.target.closest('button, select, input, textarea, label, variant-selects, form, [data-shopify-xr], .swiper-button-prev, .swiper-button-next, .swiper-pagination, .gallery-controls, .slider-nav, .jdgm-widget, .jdgm-preview-badge, .jdgm-star')) {
      return;
    }

    const card = e.target.closest('.card--product, .clicked-product, .pcard');
    if (!card) return;

    // Find the product link inside the card
    const link = card.querySelector('a[href*="/products/"]');
    if (!link || !link.href) return;

    const targetLink = e.target.closest('a');
    const targetHref = targetLink?.href || link.href;

    if (targetHref && targetHref.includes('/products/')) {
      e.preventDefault();
      window.location.href = targetHref;
    }
  }, false);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCardDirectClick);
} else {
  initProductCardDirectClick();
}
